module.exports = __webpack_public_path__ + "img/mobile-banner0-th.04558cb5.jpg";